import * as api from '../api';
import { actionTypes } from 'redux-resource';

export const fetchAllPlans =
  (params = {}) =>
  (dispatch) => {
    const actionDefaults = {
      resourceType: 'simoPlans',
      requestKey: 'fetchAll',
      list: `fetchAllPlans`,
      mergeListIds: false,
    };

    dispatch({
      ...actionDefaults,
      type: actionTypes.READ_RESOURCES_PENDING,
    });

    return api
      .fetchAllSimoPlans(params)
      .then((results) => {
        dispatch({
          ...actionDefaults,
          type: actionTypes.READ_RESOURCES_SUCCEEDED,
          resources: results,
          mergeResources: false,
        });
      })
      .catch((err) => {
        dispatch({
          ...actionDefaults,
          type: actionTypes.READ_RESOURCES_FAILED,
          requestProperties: {
            message: err.response && err.response.details,
          },
        });
      });
  };
